export default "__VITE_ASSET__CrxJQwf8__"